import { HotelPurchaseLiteModel } from 'api-hooks/order/hotel';
import { NavigationRoutes } from 'common/constants';
import { PaginationMeta } from 'common/repositories/common.model';
import { TableComponent } from 'components/elements';
import PaginationComponent from 'components/elements/pagination-component';
import { IColumn } from 'components/elements/table-component/table-component';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import { TableContainer } from 'legacy-modules/styles';
import React from 'react';

interface Props {
  hotelPurchases: HotelPurchaseLiteModel[];
  loading?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  meta?: PaginationMeta;
  sortColumns: IColumn<any>[];
}

export default function HotelPurchaseTable(props: Props) {
  const { hotelPurchases, sortColumns, loading, page, onPageChange, meta } =
    props;

  const permission = useGetCrudPermission('hotel-purchases');

  const columns = React.useMemo<IColumn<any>[]>(
    () => [
      {
        header: '#',
        accessorKey: 'index',
        stickyLeft: true,
        minSize: 40,
        size: 40,
        maxSize: 40,
        cell: ({ row }) => {
          return (
            <>
              {row.index +
                1 +
                ((meta?.currentPage || 1) - 1) * (meta?.perPage || 1)}
            </>
          );
        },
      },
      ...sortColumns,
    ],
    [meta?.currentPage, meta?.perPage, sortColumns],
  );

  return (
    <>
      <TableContainer>
        <TableComponent
          columns={columns}
          isLoading={loading}
          data={hotelPurchases || []}
          rowLink={(row) => {
            if (!permission.view) return undefined;
            return {
              pathname: NavigationRoutes.HotelPurchasesView,
              query: {
                id: row.original.id,
              },
            };
          }}
        />
      </TableContainer>
      <PaginationComponent
        page={page}
        onPageChange={onPageChange}
        meta={meta}
      />
    </>
  );
}
